import { ensure, ensureArray, stringType, TType } from "types";

export interface IURLParams {
  [key: string]: any;
}

export type TSortOrder = "DESC" | "ASC";

export interface IURLSortConfig {
  sortBy: string;
  order: TSortOrder;
}

export interface IURLPageConfig {
  page: number;
  size: number;
}

export interface IURLFilterConfig extends IURLParams {}

export const urlSortConfig: TType<IURLSortConfig> = {
  sortBy: stringType(""),
  order: stringType("DESC"),
};

export const urlSortConfigType = ensure<IURLSortConfig>(urlSortConfig);

export const urlPageConfigConfig: TType<IURLPageConfig> = {
  page: v => (!isNaN(parseInt(v, 10)) ? parseInt(v, 10) : 0),
  size: v => (!isNaN(parseInt(v, 10)) ? parseInt(v, 10) : 20),
};

export const urlPageConfigType = ensure<IURLPageConfig>(urlPageConfigConfig);

export interface IURLSearchParams<F = any> extends Partial<IURLPageConfig> {
  sortConfig?: IURLSortConfig[];
  filtersConfig?: F;
}

export const urlSearchParamsConfig: TType<IURLSearchParams> = {
  ...urlPageConfigConfig,
  sortConfig: v => ensureArray(urlSortConfigType)(v),
  filtersConfig: v => v,
};

export const urlSearchParamsType = ensure<IURLSearchParams>(urlSearchParamsConfig);
